import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as L from "leaflet";
import { useRoot } from "../../../context/root";
import { DetailsInterface } from "../../../types";
import { createFakeSrcSetObject } from "../../../utils";
import { iconHtml } from "../../common/Icon/utils";
import { useMap } from "../../../context/map";
import { useIsMobile } from "../../../hooks/useIsMobile";

export const useCard = (data: DetailsInterface) => {
  const { id } = data;
  const navigator = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { rootDispatch, extraMarker } = useRoot();
  const { mapContext } = useMap(); 
  const { geohash } = useParams();
  const { isMobile } = useIsMobile();

  const showCardDetails = () => {
    if (mapContext && !isMobile) {
      const position: any = data.location.split(',');
      mapContext.flyTo(position, 12);
      const marker = L.marker(position, {
        icon: L.divIcon({
          className: 'abc',
          iconAnchor: [30, 30],
          html: iconHtml({ 
            data: {
              data: data,
              count: 0,
              detailsUrl: null,
              geohash: "",
              coordinates: [0, 0]
            },
            active: true 
          }),
        }),
        zIndexOffset: 500,
      });
      if (extraMarker) {
        mapContext.removeLayer(extraMarker.marker);
      }
      mapContext.addLayer(marker);
      rootDispatch({
        type: "setExtraMarker",
        data: { marker, data },
        mapContext
      })
      
    }
    if (geohash) {
      navigator({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}bucket/${geohash}/details/${id}`,
        search: searchParams.toString()
      })
    }
    else {
      navigator({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}details/${id}`,
        search: searchParams.toString()
      })
    }
  }

  return {
    showCardDetails,
    picture: createFakeSrcSetObject(data.picture || null),
    itemTypeLowerCase: data.itemType.toLowerCase(),
  }
}
